import { render, staticRenderFns } from "./dashboardAgentGare.vue?vue&type=template&id=55186550&scoped=true"
import script from "./dashboardAgentGare.vue?vue&type=script&lang=js"
export * from "./dashboardAgentGare.vue?vue&type=script&lang=js"
import style0 from "./dashboardAgentGare.vue?vue&type=style&index=0&id=55186550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55186550",
  null
  
)

export default component.exports